<template>
  <label class="select-input">
    <select v-bind="$attrs" class="select-input__input" @change="handleChange">
      <option v-if="placeholder" :selected="!value">
        {{ placeholder }}
      </option>
      <option
        v-for="option in options"
        :key="option.value"
        :selected="value === option.value"
        :value="option.value"
      >
        {{ option.name }}
      </option>
    </select>
    <div class="select-input__append">
      <ChevronDown />
    </div>
  </label>
</template>

<script>
import ChevronDown from '@/components/icons/ChevronDown';

export default {
  components: {
    ChevronDown
  },
  inheritAttrs: false,
  modelValue: {
    type: String,
    required: false,
    default: null
  },
  props: {
    options: {
      type: Array,
      required: true,
      validator: value =>
        value.every(v => ('name' in v) && ('value' in v))
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: String,
      required: false,
      default: null
    }
  },
  methods: {
    handleChange(event) {
      const value =
        this.placeholder === event.target.value
          ? undefined
          : event.target.value;
      this.$emit('update:modelValue', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.select-input {
  background-color: color('white');
  border: 1px solid shade('white', 7%);
  display: flex;
  height: 3rem;
  position: relative;
  width: 100%;

  &__input {
    @include font('open-sans', 'normal');
    @include font-size('paragraph', 'md');
    appearance: none;
    background-color: transparent;
    background-image: none;
    border: 0;
    box-shadow: none;
    color: color('black');
    flex-grow: 1;
    outline: 0;
    padding: 0 spacing('md');
    text-align: left;
    width: 100%;

    &::placeholder {
      color: color('gray');
    }
  }

  &__append {
    align-items: center;
    background-color: inherit;
    bottom: 0;
    color: color('primary');
    display: flex;
    justify-content: center;
    padding: 0 spacing('md');
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
